/* EVENTS */
export const GET_TELECONSULT = "GET_TELECONSULT"
export const GET_TELECONSULT_SUCCESS = "GET_TELECONSULT_SUCCESS"
export const GET_TELECONSULT_FAIL = "GET_TELECONSULT_FAIL"

export const GET_TELECONSULT_DETAILS = "GET_TELECONSULT_DETAILS"
export const GET_TELECONSULT_DETAILS_SUCCESS = "GET_TELECONSULT_DETAILS_SUCCESS"
export const GET_TELECONSULT_DETAILS_FAIL = "GET_TELECONSULT_DETAILS_FAIL"

export const ADD_NEW_TELECONSULT = "ADD_NEW_TELECONSULT"
export const ADD_TELECONSULT_SUCCESS = "ADD_TELECONSULT_SUCCESS"
export const ADD_TELECONSULT_FAIL = "ADD_TELECONSULT_FAIL"

export const UPDATE_TELECONSULT = "UPDATE_TELECONSULT"
export const UPDATE_TELECONSULT_SUCCESS = "UPDATE_TELECONSULT_SUCCESS"
export const UPDATE_TELECONSULT_FAIL = "UPDATE_TELECONSULT_FAIL"

export const DELETE_TELECONSULT = "DELETE_TELECONSULT"
export const DELETE_TELECONSULT_SUCCESS = "DELETE_TELECONSULT_SUCCESS"
export const DELETE_TELECONSULT_FAIL = "DELETE_TELECONSULT_FAIL"

export const CONFIRM_TELECONSULT = "CONFIRM_TELECONSULT"
export const CONFIRM_TELECONSULT_SUCCESS = "CONFIRM_TELECONSULT_SUCCESS"
export const CONFIRM_TELECONSULT_FAIL = "CONFIRM_TELECONSULT_FAIL"

export const COMPLETE_TELECONSULT = "COMPLETE_TELECONSULT"
export const COMPLETE_TELECONSULT_SUCCESS = "COMPLETE_TELECONSULT_SUCCESS"
export const COMPLETE_TELECONSULT_FAIL = "COMPLETE_TELECONSULT_FAIL"

export const ADD_REMARKS_TELE_APPOINTMENTS = "ADD_REMARKS_TELE_APPOINTMENTS"
export const ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS = "ADD_REMARKS_TELE_APPOINTMENTS_SUCCESS"
export const ADD_REMARKS_TELE_APPOINTMENTS_FAIL = "ADD_REMARKS_TELE_APPOINTMENTS_FAIL"

export const RESET_TELECONSULT_STATE = 'RESET_TELECONSULT_STATE';
